import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './pdf.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfCard = ({ title, file }) => {
  const [numPages, setNumPages] = useState(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        setContainerWidth(entries[0].contentRect.width);
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <>
      <div className="pdf-card prevent-select">
        <div className="pdf-viewer-container" ref={containerRef}>
          <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
            <Page 
              pageNumber={1} 
              width={containerWidth} 
              renderAnnotationLayer={false} 
              renderTextLayer={false} 
            />
          </Document>
        </div>
        
        <div className="pdf-info">
          <h4 className="pdf-title">{title}</h4>
          <button className="pdf-icon-btn" onClick={() => setIsOpen(true)}>
           Read More
          </button>
        </div>
      </div>

      {isOpen && createPortal(
        <div className="pdf-full-modal" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 99999, display: 'flex', flexDirection: 'column' }}>
          <div className="modal-header" style={{ padding: '16px', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', zIndex: 10 }}>
            <h3 style={{ margin: 0, color: '#333' }}>{title}</h3>
            <button className="close-btn" onClick={() => setIsOpen(false)} style={{ padding: '8px 16px', cursor: 'pointer' }}>Close</button>
          </div>
          <div className="modal-content" style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '40px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#f5f5f5' }}>
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
              {Array.from(new Array(numPages), (el, index) => (
                <div key={`page_wrapper_${index + 1}`} style={{ marginBottom: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                  <Page 
                    pageNumber={index + 1} 
                    width={Math.min(window.innerWidth - 40, 800)}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                </div>
              ))}
            </Document>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default PdfCard;